import { SiteDisconnectMutationOptions, useSiteDisconnectMutation } from '@occc/graphql';

import { useMutation } from '../utils';

export const useSiteDisconnect = (baseOptions: SiteDisconnectMutationOptions) =>
  useMutation(useSiteDisconnectMutation, baseOptions);
